import { logInfo } from '../../shared/utils/logging';
import { REGISTERED_APPS } from '../../shared/types/Apps';
import CandyCartDocumentListenerUtils from './candyCartDocumentListenerUtils';
import CandyCartCloningButtonUtils from './candyCartCloningButtonsUtils';

class Buttons {
  private readonly utils:
    | CandyCartDocumentListenerUtils
    | CandyCartCloningButtonUtils;

  constructor(eventName: string) {
    if (window.CHECKOUT_BUTTON_DOCUMENT_LISTENER) {
      logInfo(
        'Initializing Checkout Button document listener',
        REGISTERED_APPS.CHECKOUT_BUTTON,
      );
      this.utils = new CandyCartDocumentListenerUtils(eventName);
      this.utils.setupDocumentListener();
    } else {
      logInfo(
        'Initializing Checkout Button cloning buttons',
        REGISTERED_APPS.CHECKOUT_BUTTON,
      );
      this.utils = new CandyCartCloningButtonUtils(eventName);
    }
    logInfo('loaded buttons', REGISTERED_APPS.CHECKOUT_BUTTON);
  }

  /*
   ** Delegates function, relevant only for cloned buttons
   */
  public initCustomCartWatcherForCloneButtons(selector: string | null): void {
    if (this.utils instanceof CandyCartCloningButtonUtils) {
      this.utils.initCustomCartWatcherForCloneButtons(selector);
    }
  }
}

export default Buttons;
